<template>
    <div class="flex flex-wrap">
        <div
            v-for="(item, index) in base"
            v-show="!item.scope || $ability.hasPermission(item.scope)"
            :key="index"
            class="w-full lg:w-1/2 flex justify-center"
        >
            <button
                class="btn bg-stack-primary text-white my-2 text-left min-h-32 w-11/12 flex flex-col items-start"
                :class="
                    itemsCurrent.includes(item.id)
                        ? 'border-4 border-stack-emphasis'
                        : ''
                "
                @click="selectItem(item.id)"
            >
                <div class="w-full flex justify-between items-center">
                    <span class="text-lg">{{ item.name }}</span>
                    <span>{{ item.icon || "🔍" }}</span>
                </div>
                <p>{{ item.description }}</p>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "CardsSelector",
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        itemsCurrent: {
            default: () => [],
            type: Array,
            require: true
        },
        base: {
            default: () => [],
            type: Array,
            require: true
        }
    },
    emits: ["change"],
    data: () => ({
        selectedItems: []
    }),
    watch: {},
    methods: {
        selectItem(id) {
            const itemsCurrentTemp = [...this.itemsCurrent];
            const itemToPush = this.base.find((item) => item.id === id);
            if (itemToPush) {
                const fromIndex = itemsCurrentTemp.findIndex(
                    (item) => item === id
                );

                if (fromIndex < 0) {
                    itemsCurrentTemp.push(itemToPush.id);
                    if (
                        "conflicts" in itemToPush &&
                        itemToPush.conflicts.length
                    ) {
                        for (const item of itemToPush.conflicts) {
                            const fromIndexItem = itemsCurrentTemp.findIndex(
                                (item3) => item3 === item
                            );
                            if (fromIndexItem >= 0) {
                                itemsCurrentTemp.splice(fromIndexItem, 1);
                            }
                        }
                    }
                } else {
                    itemsCurrentTemp.splice(fromIndex, 1);
                }
                this.$emit("change", itemsCurrentTemp);
            }
        }
    }
};
</script>
